import { Button } from 'base/ui/button';
import { IconGoogle } from 'base/ui/icons';
import { randomUUID } from 'base/uuid';
import React, { useCallback } from 'react';

const clientId =
  '421451824897-q086pfnm80orit27prjgpctnmjadhoiv.apps.googleusercontent.com';
const googleAuthUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

export const NONCE_KEY = 'google_auth_nonce';
export const STATE_KEY = 'google_auth_state';

export function useGoogleOAuth() {
  const redirectUri = `${window.location.origin}/app/callbacks/google_callback`;

  const signInWithGoogle = useCallback(() => {
    const state = randomUUID();
    const nonce = randomUUID();

    sessionStorage.setItem(STATE_KEY, state);
    sessionStorage.setItem(NONCE_KEY, nonce);
    const authUrl = new URL(googleAuthUrl);
    authUrl.searchParams.append('client_id', clientId);
    authUrl.searchParams.append('redirect_uri', redirectUri);
    authUrl.searchParams.append('response_type', 'id_token');
    authUrl.searchParams.append('scope', 'email profile');
    //https://developers.google.com/identity/gsi/web/reference/html-reference#data-nonce
    authUrl.searchParams.append('nonce', nonce);
    authUrl.searchParams.append('state', state);

    // Redirect to Google's OAuth page
    window.location.href = authUrl.toString();
  }, [redirectUri]);

  return {
    signInWithGoogle,
  };
}

export function GoogleOAuthButton({
  text = 'Continue with Google',
}: {
  text?: string;
}) {
  const { signInWithGoogle } = useGoogleOAuth();

  return (
    <Button
      variant="secondary"
      label={text}
      icon={IconGoogle}
      onClick={() => {
        signInWithGoogle();
      }}
      size="large"
    />
  );
}
